module.exports = __webpack_public_path__ + "assets/img/portfolio.accc535e.webp";